import React from "react";
import { useAppSelector } from "./useAppSelector";

const useAuth = () => {
  const { id, username } = useAppSelector((state) => state.auth);

  const isLoggedIn = id !== undefined;

  return {
    isLoggedIn,
    username,
    id,
  };
};

export default useAuth;
